import { mapState } from 'vuex'

import { getMultipleUsers, getUser, getUsersFromGraph } from '../services'

const FormFieldGraphSearch = {
  data () {
    return {
      graphBasedFields: [],
      search: {},
      graph: {}
    }
  },
  computed: {
    ...mapState({
      localUsers: state => state.localUsers
    })
  },
  created () {
    // prepare fields handling
    if (this.form) {
      this.graphBasedFields.forEach(async (name) => {
        this.$set(this.graph, name, {
          items: Object.values(this.localUsers),
          isLoading: false
        })

        this.$set(this.search, name, '')
        this.$watch(
          () => this.search[name],
          (v) => {
            this.onPersonFieldChange(name, v)
          }
        )

        // check current values
        const field = this.form[name]
        if (typeof field === 'string' && field) {
          const user = await getUser(field)
          this.search[name] = user.displayName
          this.form[name] = user
        } else if (field && typeof field === 'object' && field.length) {
          const users = await getMultipleUsers(field)
          this.form[name] = users
        }
      })
    }
  },
  watch: {
    form (v, p) {
      if (v && !p) {
        this.graphBasedFields.forEach(async (name) => {
          this.$set(this.graph, name, {
            items: Object.values(this.localUsers),
            isLoading: false
          })

          this.$set(this.search, name, '')
          this.$watch(
            () => this.search[name],
            (v) => {
              this.onPersonFieldChange(name, v)
            }
          )

          // check current values
          const field = this.form[name]
          if (typeof field === 'string' && field) {
            const user = await getUser(field)
            this.search[name] = user.displayName
            this.form[name] = user
          } else if (field && typeof field === 'object' && field.length) {
            const users = await getMultipleUsers(field)
            this.form[name] = users
          }
        })
      }
    }
  },
  methods: {
    onPersonFieldChange (targetName, value) {
      const target = this.graph[targetName]

      if (target.isLoading) return // serves as simple throttling ;)
      target.items = Object.values(this.localUsers)

      if (value && value.length > 2) {
        if (!(this.form[targetName] && this.form[targetName].mailNickname)) {
          target.isLoading = true
          this.getUsersByText(value)
            .then(items => {
              target.items.push(...items)
            })
            .catch(error => {
              target.items = []
              console.error(error)
            })
            .finally(() => {
              target.isLoading = false
            })
        }
      } else {
        if (target.isLoading) target.isLoading = false
      }
    },
    async getUsersByText (text) {
      return getUsersFromGraph({
        $search: `"displayName:${text}"`,
        $filter: "accountEnabled eq true and not startsWith(mailNickname, 'a7') and endsWith(userPrincipalName, 'vattenfall.com')",
        $top: 7
      })
    }
  }
}

export default FormFieldGraphSearch
